import request from "@/utils/request";
import base from './base';

// 删除原有的 host 定义
export const host = base.api_data;

const api_store_locations = "/expand/store-locations/"; // 门店位置列表
const api_update_location = "/expand/store-locations/update_location/"; // 更新门店位置
const api_competition = "/expand/competition/"; // 竞争对手位置列表

export default {
    // 获取门店位置列表
    api_store_locations(params) {
        return request({
            url: `${host}${api_store_locations}`,
            method: 'get',
            params: params
        });
    },

    // 更新门店位置信息
    api_update_location(data) {
        return request.post(
            `${host}${api_update_location}`,
            JSON.stringify(data),
            {
                headers: { 'Content-Type': 'application/json' }
            }
        );
    },

    // 获取竞争对手列表
    api_get_competition(params) {
        return request({
            url: `${host}${api_competition}`,
            method: 'get',
            params: params
        });
    },

    // 添加竞争对手
    api_add_competition(data) {
        return request({
            url: `${host}${api_competition}`,
            method: 'post',
            data: JSON.stringify(data),
            headers: { 'Content-Type': 'application/json' }
        });
    },

    // 更新竞争对手信息
    api_update_competition(id, data) {
        return request({
            url: `${host}${api_competition}${id}/`,
            method: 'put',
            data: JSON.stringify(data),
            headers: { 'Content-Type': 'application/json' }
        });
    },

    // 删除竞争对手
    api_delete_competition(id) {
        return request({
            url: `${host}${api_competition}${id}/`,
            method: 'delete'
        });
    }
};
